import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import {LeistungProvider} from '../../providers/leistung/leistung';

/**
 * Generated class for the SelectLeistungPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-select-leistung',
  templateUrl: 'select-leistung.html',
})
export class SelectLeistungPage {
Leistungsartikel = [];
loading: any;
mode = {create:true};
  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private rhynoApi: RhynoApiProvider,
    public loadingCtrl: LoadingController,
  	public leistungCtrl: LeistungProvider) {

    this.mode = navParams.data;

	  this.getData();
  }
  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }
  getData(){
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();
    let kunde = ''
    if (this.mode.create==true){
      kunde = this.leistungCtrl.leistung.Kunde
    }
    else {
      kunde = this.leistungCtrl.leistungEdit.Kunde
    }
    this.rhynoApi.getLeistungsartikel(kunde).subscribe(
      data => {
      if (data.success){
        this.Leistungsartikel = data.data; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Leistungsartikel Search Complete')
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectLeistungPage');
  }
  select(data){
    this.leistungCtrl.setLeistung(data, this.mode.create);
  	this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-leistung/select-leistung.ts